import { IconShoppingCart } from '@tabler/icons-react'
import clsx from 'clsx'
import { ListItemWithAssetSchema } from 'cms/schemaTypes/staticPages/objects/listItemWithAsset'
import Image from 'next/image'
import { PortableText } from 'next-sanity'
import SoldOut from 'public/static/campaigns/rewards-program/sold-out.webp'

import { urlFor } from 'lib/sanity/image'

import { RewardItemMetadataSchema } from '../api'

import styles from './HowItWorksStep.module.scss'

const numberMapper = {
  1: 'pierwszy prezent',
  2: 'drugi prezent',
  3: 'trzeci prezent',
  4: 'czwarty prezent',
  5: 'piąty prezent',
  6: 'szósty prezent',
  7: 'siómy prezent',
  8: 'ósmy prezent'
}

const getDataJson = <T,>(v: string, defaultValue: T): T => {
  try {
    return JSON.parse(v) as T
  } catch {
    return defaultValue
  }
}

export interface HowItWorksStepProps {
  item: ListItemWithAssetSchema
  imageLeft: boolean
  stepNumber: number
}

const HowItWorksStep = ({
  item,
  imageLeft = true,
  stepNumber
}: HowItWorksStepProps) => {
  const { header, image, content, metadata } = item

  const metadataData = getDataJson<RewardItemMetadataSchema>(
    metadata?.code || '',
    { isSoldOut: false }
  )
  const reversed = !imageLeft
  const unavailable = Boolean(metadataData.isSoldOut)

  return (
    <div className={clsx(styles.stepWrapper, reversed && styles.reversed)}>
      <div className={styles.imageWrapper}>
        <Image
          className={clsx(styles.prizeImage, unavailable && styles.unavailable)}
          src={urlFor(image.asset?.asset).url()}
          alt={image.alt}
          width={480}
          height={480}
          style={{ objectFit: 'contain' }}
        />
        {metadataData.isSoldOut && (
          <Image
            className={styles.soldOutStamp}
            src={SoldOut}
            alt={`Nagroda ${header} została wyprzedana`}
            width={480}
            height={480}
          />
        )}
      </div>
      <div
        className={clsx(
          styles.textContent,
          reversed && styles.textContentReversed,
          unavailable && styles.unavailable
        )}
      >
        <h3 className={styles.title}>
          <IconShoppingCart strokeWidth={2} width={34} height={34} />
          <PortableText value={content || []} />
        </h3>
        <p className={styles.prize}>
          {numberMapper[
            stepNumber as keyof typeof numberMapper
          ]?.toUpperCase() || ''}{' '}
          za 1 grosz
        </p>
        <p className={clsx(styles.label, reversed && styles.labelReversed)}>
          {header}
        </p>
      </div>
    </div>
  )
}

export default HowItWorksStep
